export const enum MediaTypes {
  video = 'video',
  audio = 'audio'
}
